import { useEffect, useState } from "react";
import styles from "./bio.module.css";
import logo from "../../assets/logo.svg";
import { apiBaseURL } from "../../utils/axios";
import { Link, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import {
  dispatchUser,
  dispatchLogout,
  dispatchUserToken,
  dispatchUserId,
} from "../../utils/redux/userSlice.js";
import DashboardEdit from "./dashboardEdit/DashboardEdit";
import BloodRequest from "./bloodRequest/BloodRequest";
import Donated from "./donate/Donated";
import { Badge } from "@mui/material";
import Menu from "@mui/material/Menu";
import Swal from "sweetalert2";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";

const UserBoard = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);
  const user = useSelector((state) => state.user.user);
  const userId = useSelector((state) => state.user.userId);
  const navigate = useNavigate();

  const popupState = usePopupState({
    variant: "popover",
    popupId: "demoMenu",
  });

  const [openEdit, setOpenEdit] = useState(false);

  const [requestData, setRequestData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggles = (e) => {
    setOpenEdit((prevOpenEdit) => !prevOpenEdit);
    popupState.close();
  };

  const logout = () => {
    popupState.close();
    sessionStorage.clear();
    localStorage.clear();
    localStorage.removeItem(user);
    localStorage.removeItem(token);
    dispatch(dispatchLogout(true));
    dispatch(dispatchUserToken(!token));
    dispatch(dispatchUser(!user));
    dispatch(dispatchUserId(!userId));
    Swal.fire({
      icon: "info",
      title: "Logout Successful",
      text: `${user?.firstname} have been logged out`,
      showConfirmButton: false,
      timer: 2500,
    });
    return navigate("/");
  };

  useEffect(() => {
    const ac = new AbortController();

    // if (token) {
    //   const getUser = async () => {
    //     const response = await axios.get(`${apiBaseURL}/v1/donors/${userId}`, {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });
    //     dispatch(dispatchUser(response.data.user));

    //     return () => ac.abort();
    //   };

    if (token) {
      const getUser = async () => {
        try {
          const response = await axios.get(
            `${apiBaseURL}/v1/donors/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          dispatch(dispatchUser(response.data.user));
        } catch (error) {
          if (error.name === "AbortError") {
            // Request was aborted due to component unmount
            return;
          }
          // Handle other errors, maybe dispatch an error action
        }
      };

      getUser();
      return () => ac.abort();
    }
  }, [userId, dispatch, token]);

  // User Request
  const getRequest = async () => {
    if (token) {
      try {
        const res = await axios.get(`${apiBaseURL}/v1/patients/user/request`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        dispatch(dispatchUserToken(token));
        setIsLoading(false);
        // console.log(res, "checking response");
        setRequestData(res.data);
      } catch (err) {
        // if (`${err.response.data.msg}` === "jwt malformed") {
        // if (`${err.res.data.msg}` === "jwt malformed") {
        if (err.response && err.response.status === 401) {
          logout();

          Swal.fire({
            icon: "info",
            title: "Logout Successful",
            text: `${user?.firstname} Your session timed out, kindly login again`,
            showConfirmButton: false,
            timer: 2500,
          });

          navigate("/");
        }
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (user?.requests?.length > 0) {
      getRequest();
    } else {
      setIsLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token, dispatch]);

  if (!token) {
    return <Navigate to="/" />;
  } else {
    return (
      <section className="bg-slate-50 min-h-[100vh]">
        {/* DASHBARD NAVIGATION SECTION */}
        <div className=" shadow-sm mx-auto max-w-[1440px]">
          <section className="flex justify-between items-center px-2 py-4 font-poppins relative bg-blue-50  mx-auto">
            {openEdit && (
              <>
                <DashboardEdit handleToggles={handleToggles} />
              </>
            )}
            <Link to="/">
              <img src={logo} alt="RIBI logo" className="w-full" />
            </Link>
            <div className="relative">
              {/* DROPDOWN OPTION MENU */}
              <div className="flex items-center px-3 space-x-3">
                <div className="notifik mr">
                  <Badge
                    badgeContent={user?.requests?.length}
                    color="error"
                    className="animate-pulse cursor-pointer"
                  >
                    <NotificationsNoneIcon
                      className=" hover:text-red-500 "
                      size="medium"
                    />
                  </Badge>
                  {/* </div> */}
                </div>
                <div className="flex space-x-2 items-center">
                  {/* <img
                    className="w-12 h-12 rounded-full cursor-pointer hover:opacity-50"
                    src={user.avater}
                    alt={user.firstname}
                    {...bindTrigger(popupState)}
                    onError={(event) => {
                      event.target.src =
                        "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                      event.onerror = null;
                    }}
                  /> */}
                  <p
                    className="cursor-pointer hover:opacity-50"
                    {...bindTrigger(popupState)}
                  >
                    Account
                  </p>

                  <Menu {...bindMenu(popupState)} className="top-5 left-5">
                    <div
                      className="hover:bg-red-400 cursor-pointer py-3 px-5 hover:text-white"
                      onClick={handleToggles}
                    >
                      <button>Edit Profile</button>
                    </div>
                    <div
                      className="hover:bg-red-400 cursor-pointer py-3 px-5 hover:text-white"
                      onClick={popupState.close}
                    >
                      <button>Notification</button>
                    </div>
                    <div
                      className="hover:bg-red-400 cursor-pointer py-3 px-5 hover:text-white"
                      onClick={logout}
                    >
                      <button>Logout</button>
                    </div>
                    <div className="py-3 px-5">
                      <span className="text-xs px-3 mb-2 font-bold border-t-2 text-center py-2">
                        Version 1.0.0
                      </span>
                    </div>
                  </Menu>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* ----------------------------------------------- End of Dashboard Navbar ----------------------------------- */}
        {/* Main Dashboard Body */}
        <section className="lg:flex lg:flex-row flex flex-col gap-6 py-8 my-6 shadow-lg bg-blue-50 px-4 max-w-[1440px] mx-auto">
          {/* Displaying two content */}
          <div className="flex flex-col lg:w-1/3 w-full gap-4">
            {/* ---------------------------------------- first Sitter ---------------------------------------------------- */}
            <div className="px-3 shadow-lg bg-white rounded-lg py-6">
              <div
              // className={styles.profileContainer}
              >
                <div className={styles.bloodGroup}></div>

                <div className="text-center">
                  <div className="flex flex-row items-center gap-x-6 px-3">
                    <img
                      className="w-24 h-24 rounded-full"
                      src={user.avater}
                      alt={user.firstname}
                      onError={(event) => {
                        event.target.src =
                          "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                        event.onerror = null;
                      }}
                    />
                    <div className="flex flex-col text-left">
                      <p className=" text-2xl font-bold">
                        {user.firstname} {user.lastname}
                      </p>
                      <p className="text-sm my-1">{user.email}</p>
                      <p className="text-sm ">{user.phone}</p>
                      <span className="text-blue-500 my-2 text-sm hover:text-pryclr">
                        <button onClick={handleToggles}>Edit Profile</button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ------------------------------- Second Sitter -------------------------- */}
            <div>
              <section className="bg-white  shadow-lg rounded-lg">
                <div className="px-3 py-4">
                  <div>
                    <div className="grid grid-cols-2 px-3">
                      <p className={styles.detailText}>Gender:</p>
                      <p className={styles.detailText}>{user.gender}</p>
                      <p className={styles.detailText}>Date of Birth:</p>
                      <p className={styles.detailText}>
                        {user.dateOfBirth
                          ? `${user.dateOfBirth}`.slice(0, 10)
                          : "0-0-0"}
                      </p>
                      <p className={styles.detailText}>Blood Type:</p>
                      <p className={styles.detailText}>{user.bloodType}</p>
                      <p className={styles.detailText}>Genotype:</p>
                      <p className={styles.detailText}>{user.genotype}</p>
                      <p className={styles.detailText}>Country:</p>
                      <p className={styles.detailText}>{user.country}</p>
                      <p className={styles.detailText}>Location:</p>
                      <p className={styles.detailText}>{user.donorLocation}</p>
                      <p className={styles.detailText}>State:</p>
                      <p className={styles.detailText}>{user.state}</p>
                      <p className={styles.detailText}>City/Town:</p>
                      <p className={styles.detailText}>{user.city}</p>
                      {/* <p className={styles.detailText}>Ocupation:</p>
                      <p className={styles.detailText}>Teacher</p> */}
                    </div>
                  </div>
                </div>
              </section>
            </div>

            {/* ----------- End of setters Sitter ------------- */}
          </div>
          <div className="lg:w-1/3 w-full bg-white rounded-sm px-3 shadow-lg overflow-y-auto">
            <h3 className="py-3 text-center text-lg font-semibold text-[#f6655f]">
              Pending Requests
            </h3>
            <BloodRequest
              isLoading={isLoading}
              requestData={requestData}
              setRequestData={setRequestData}
            />
          </div>
          <div className="lg:w-1/3 w-full bg-white rounded-sm px-3 shadow-lg ">
            <h3 className="text-center text-lg font-semibold text-[#268d61] py-3">
              Donated
            </h3>
            <Donated
              isLoading={isLoading}
              requestData={requestData}
              setRequestData={setRequestData}
            />
          </div>
        </section>
      </section>
    );
  }
};

export default UserBoard;
